import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';

import App from './App';
import { store } from './redux/store';
import DynamicThemeProvider from './components/ThemeProvider';
import './i18n';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* v7_startTransition: keep the current page visible while the next
          lazy page chunk loads, instead of flashing a loader */}
      <BrowserRouter future={{ v7_startTransition: true }}>
        <DynamicThemeProvider>
          <CssBaseline />
          <App />
        </DynamicThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
